import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import InputBase from '@material-ui/core/InputBase'
import Paper from '@material-ui/core/Paper'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import ArrowLeftOutlinedIcon from '@material-ui/icons/ArrowLeftOutlined'
import ArrowRightOutlinedIcon from '@material-ui/icons/ArrowRightOutlined'
import CloseIcon from '@material-ui/icons/Close'
import { useFlow } from 'contexts/Flow/flowContext'
import GetIntentsByProperties from 'controllers/intent/GetIntentsByProperties'
import React, { useState } from 'react'
import MttTypography from '../../Material/MttTypography/MttTypography'
import {
  markHighlighted,
  markSearch,
  panToNode,
  umarkSearch,
  unmarkHighlighted,
} from '../utils/NodeContainer'
import { FilterFieldProps } from './types'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: 450,
      position: 'absolute',
      top: 184,
      left: '50%',
      transform: 'translateX(-50%)',
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    results: {
      margin: 5,
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: '0.9rem',
    },
    iconButton: {
      padding: 10,
    },
    divider: {
      height: 28,
      margin: 4,
    },
  }),
)

export default function FilterField(props: FilterFieldProps) {
  const { state } = useFlow()

  const { handleClose } = props

  const [search, setSearch] = useState('')
  const [totalResults, setTotalResults] = useState<string[]>([])
  const [currentResult, setCurrentResult] = useState(0)

  const classes = useStyles()

  const block = state.editorFlow?.drawflow.drawflow.Home.data

  const handleSearchIntent = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setSearch(e.target.value)

    if (block && e.target.value) {
      const keys = new GetIntentsByProperties().getIntents(
        block,
        e.target.value,
      )
      setTotalResults(keys)
      markSearch(keys)
      setCurrentResult(0)
    } else {
      umarkSearch()
      unmarkHighlighted()
    }
  }

  const handleNextItemOnSearch = () => {
    let curr
    if (currentResult < totalResults.length) {
      setCurrentResult(currentResult + 1)
      curr = currentResult
    } else {
      setCurrentResult(1)
      curr = 0
    }
    markHighlighted(totalResults[curr])
    goToNode(curr)
  }

  const handlePreviousItemOnSearch = () => {
    let curr
    if (currentResult > 1) {
      setCurrentResult(currentResult - 1)
      curr = currentResult - 2
    } else {
      setCurrentResult(totalResults.length)
      curr = totalResults.length - 1
    }

    markHighlighted(totalResults[curr])
    goToNode(curr)
  }

  const goToNode = (curr: number) => {
    if (state.editorFlow) {
      panToNode(state.editorFlow, totalResults[curr])
    }
  }

  const handleCloseAndCleanSearch = () => {
    umarkSearch()
    handleClose()
    unmarkHighlighted()
  }

  return (
    <Paper
      component="form"
      className={classes.root}
      onSubmit={(e: React.FormEvent<HTMLDivElement>) => e.preventDefault()}
    >
      <InputBase
        className={classes.input}
        placeholder="Busque a intenção"
        inputProps={{ 'aria-label': 'busque a intenção' }}
        value={search}
        onChange={handleSearchIntent}
        autoFocus
      />

      <MttTypography variant="subtitle1" className={classes.results}>
        {search && `${currentResult}/${totalResults.length}`}
      </MttTypography>
      <Divider className={classes.divider} orientation="vertical" />

      <IconButton
        size="small"
        onClick={handlePreviousItemOnSearch}
        disabled={!(totalResults.length !== 0) || !!!search}
      >
        <ArrowLeftOutlinedIcon />
      </IconButton>

      <IconButton
        size="small"
        onClick={handleNextItemOnSearch}
        disabled={!(totalResults.length !== 0) || !!!search}
      >
        <ArrowRightOutlinedIcon />
      </IconButton>

      <Divider className={classes.divider} orientation="vertical" />
      <IconButton
        color="primary"
        className={classes.iconButton}
        aria-label="directions"
        onClick={handleCloseAndCleanSearch}
      >
        <CloseIcon />
      </IconButton>
    </Paper>
  )
}
